<template>
  <div class="scrollbar">
    <loader
      :pageloader_value="pageLoader"
      :type="'complete'"
      v-if="pageLoader"
    ></loader>
    <message
      :message="response_msg"
      :messageType="msg_type"
      v-if="response_msg != ''"
    ></message>
    <div class="col-12 inMiddle-area mt-2">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <!-- {{ dashboardData }} -->
            <div class="col-12 col-md-3">
              <div class="card custom-card border-0">
                <div class="card-body">
                  <div class="card-item">
                    <div class="card-item-icon card-icon">
                      <feather type="users" size="17px"></feather>
                    </div>
                    <div class="card-item-title mb-3">
                      <label
                        class="main-content-label tx-13 font-weight-bold mb-0"
                        >Total Sub-Affiliate</label
                      >
                      <!-- <span class="d-block tx-12 mb-0 text-muted">Previous month vs this months</span>  -->
                    </div>
                    <div
                      class="card-item-body"
                      v-if="
                        dashboardData.length > 0 &&
                        dashboardData[0].hasOwnProperty('totalIB')
                      "
                    >
                      <div class="card-item-stat">
                        <h4
                          class="font-weight-bold"
                          v-html="
                            dashboardData[0].totalIB != '' &&
                            dashboardData[0].totalIB != null
                              ? dashboardData[0].totalIB
                              : 0
                          "
                        ></h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-3">
              <div class="card custom-card border-0">
                <div class="card-body">
                  <div class="card-item">
                    <div class="card-item-icon card-icon">
                      <feather type="airplay" size="17px"></feather>
                    </div>
                    <div class="card-item-title mb-3">
                      <label
                        class="main-content-label tx-13 font-weight-bold mb-0"
                        >Total Clients</label
                      >
                      <!-- <span class="d-block tx-12 mb-0 text-muted">Previous month vs this months</span>  -->
                    </div>
                    <div
                      class="card-item-body"
                      v-if="
                        dashboardData.length > 0 &&
                        dashboardData[0].hasOwnProperty('dashboardData') &&
                        dashboardData[0].dashboardData != null &&
                        Object.keys(dashboardData[0].dashboardData).length > 0
                      "
                    >
                      <div class="card-item-stat">
                        <h4
                          class="font-weight-bold"
                          v-html="
                            dashboardData[0].dashboardData.total_client != '' &&
                            dashboardData[0].dashboardData.total_client != null
                              ? dashboardData[0].dashboardData.total_client
                              : 0
                          "
                        ></h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-3">
              <div class="card custom-card border-0">
                <div class="card-body">
                  <div class="card-item">
                    <div class="card-item-icon card-icon">
                      <feather type="check-circle" size="17px"></feather>
                    </div>
                    <div class="card-item-title mb-3">
                      <label
                        class="main-content-label tx-13 font-weight-bold mb-0"
                        >Verified Clients</label
                      >
                      <!-- <span class="d-block tx-12 mb-0 text-muted">Previous month vs this months</span>  -->
                    </div>
                    <div
                      class="card-item-body"
                      v-if="
                        dashboardData.length > 0 &&
                        dashboardData[0].hasOwnProperty('dashboardData') &&
                        dashboardData[0].dashboardData != null &&
                        Object.keys(dashboardData[0].dashboardData).length > 0
                      "
                    >
                      <div class="card-item-stat">
                        <h4
                          class="font-weight-bold"
                          v-html="
                            dashboardData[0].dashboardData.verified_client !=
                              '' &&
                            dashboardData[0].dashboardData.verified_client !=
                              null
                              ? dashboardData[0].dashboardData.verified_client
                              : 0
                          "
                        ></h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-3">
              <div class="card custom-card border-0">
                <div class="card-body">
                  <div class="card-item">
                    <div class="card-item-icon card-icon">
                      <feather type="archive" size="17px"></feather>
                    </div>
                    <div class="card-item-title mb-3">
                      <label
                        class="main-content-label tx-13 font-weight-bold mb-0"
                        >Funded Clients</label
                      >
                      <!-- <span class="d-block tx-12 mb-0 text-muted">Previous month vs this months</span>  -->
                    </div>
                    <div
                      class="card-item-body"
                      v-if="
                        dashboardData.length > 0 &&
                        dashboardData[0].hasOwnProperty('dashboardData') &&
                        dashboardData[0].dashboardData != null &&
                        Object.keys(dashboardData[0].dashboardData).length > 0
                      "
                    >
                      <div class="card-item-stat">
                        <h4
                          class="font-weight-bold"
                          v-if="dashboardData[0].dashboardData"
                          v-html="
                            dashboardData[0].dashboardData.total_funded != '' &&
                            dashboardData[0].dashboardData.total_funded != null
                              ? dashboardData[0].dashboardData.total_funded
                              : 0
                          "
                        ></h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 space rightFilterSearch mb-0">
          <div class="selectFilter-type d-flex justify-content-between">
            <ul class="tableFilDate d-flex align-items-center">
              <li
                @click.prevent="
                  selectKey = 0;
                  listing();
                "
                :class="selectKey == 0 ? 'active' : ''"
              >
                All
                <sub
                  v-if="
                    dashboardData.length > 0 &&
                    dashboardData[0].hasOwnProperty('totalIB') &&
                    dashboardData[0].totalIB != null &&
                    dashboardData[0].totalIB != ''
                  "
                  >{{ dashboardData[0].totalIB }}</sub
                >
              </li>
              <li
                @click.prevent="
                  selectKey = 1;
                  listing();
                "
                :class="selectKey == 1 ? 'active' : ''"
              >
                Active
                <sub
                  v-if="
                    dashboardData.length > 0 &&
                    dashboardData[0].hasOwnProperty('activeIB') &&
                    dashboardData[0].activeIB != null &&
                    dashboardData[0].activeIB != ''
                  "
                  >{{ dashboardData[0].activeIB }}</sub
                >
              </li>
              <li
                @click.prevent="
                  selectKey = 2;
                  listing();
                "
                :class="selectKey == 2 ? 'active' : ''"
              >
                Closed
                <sub
                  v-if="
                    dashboardData.length > 0 &&
                    dashboardData[0].hasOwnProperty('closedIB') &&
                    dashboardData[0].closedIB != null &&
                    dashboardData[0].closedIB != ''
                  "
                  >{{ dashboardData[0].closedIB }}</sub
                >
              </li>
            </ul>
            <app-top-header-title ref="form"></app-top-header-title>
          </div>
        </div>
        <div class="col-12">
          <div class="whiteBG box-shadow">
            <div
              class="tableHead-title d-flex align-items-center justify-content-between mb-2"
            >
              <label class="font-weight-bold"> List</label>
              <div class="rtl d-flex align-items-center">
                <ul class="selectmotr d-flex align-items-center">
                  <li>
                    <a
                      href="javascript:void(0);"
                      v-bind:class="[statInfo.interval == 'd' ? 'active' : '']"
                      @click.prevent="eventInterValFl('d', 'stat')"
                      >Day</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      v-bind:class="[statInfo.interval == 'm' ? 'active' : '']"
                      @click.prevent="eventInterValFl('m', 'stat')"
                      >Month</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      v-bind:class="[statInfo.interval == 'y' ? 'active' : '']"
                      @click.prevent="eventInterValFl('y', 'stat')"
                      >Year</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      v-bind:class="[statInfo.interval == '' ? 'active' : '']"
                      @click.prevent="eventInterValFl('', 'stat')"
                      >All</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      v-bind:class="[
                        statInfo.interval == 'custom' ? 'active' : '',
                      ]"
                      @click.prevent="openToggle = !openToggle"
                      >Custom</a
                    >
                    <div class="mainFilterBytime modHalf">
                      <div
                        class="cutDropdown pt-0 px-0 pb-4"
                        :class="openToggle ? 'active' : ''"
                      >
                        <ul class="datPickerT">
                          <li
                            class="headTitle d-flex align-items-center justify-content-between"
                          >
                            <span>Select Date</span>
                          </li>
                          <li class="d-flex align-items-center p-3">
                            <div
                              class="mx-datepicker form-control whiteBG pt-0"
                            >
                              <label>From</label>
                              <input
                                class="customflaotField mdb-select md-form form-control pt-0"
                                type="date"
                                v-model="statInfo.from"
                                name="dob1"
                                v-validate="'required|before:beforeTarget'"
                                :max="maxDate()"
                                :class="
                                  (statInfo.from != '' &&
                                  statInfo.from != 'Invalid Date'
                                    ? 'active'
                                    : '') || {
                                    'is-invalid':
                                      submittedRequest && errors.has('dob'),
                                  }
                                "
                                :disabled="disable"
                              />
                            </div>
                            <div class="mx-datepicker">
                              <label>To</label>
                              <input
                                class="customflaotField mdb-select md-form form-control pt-0"
                                type="date"
                                v-model="statInfo.to"
                                name="dob2"
                                v-validate="'required|before:beforeTarget'"
                                :max="maxDate()"
                                :class="
                                  (statInfo.to != '' &&
                                  statInfo.to != 'Invalid Date'
                                    ? 'active'
                                    : '') || {
                                    'is-invalid':
                                      submittedRequest && errors.has('dob'),
                                  }
                                "
                                :disabled="disable"
                              />
                            </div>
                            <div
                              class="closeIcon"
                              @click.prevent="
                                openToggle = !openToggle;
                                statInfo.from = '';
                                statInfo.to = '';
                              "
                            >
                              <feather type="x"></feather>
                            </div>
                          </li>
                          <li class="px-3 pt-3">
                            <a
                              href="#"
                              @click.prevent="eventInterValFl('custom', 'stat')"
                              class="grd_btn greenBG"
                              >Submit</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="download-table-data ml-3">
                  <a
                    title="Download Data"
                    @click.prevent="
                      csvExport(
                        subIbList.records,
                        'affiliate_detail',
                        'affiliate_detail.csv'
                      )
                    "
                    ><img
                      src="../../../../static/fxView/images/excel.png"
                      alt="Icon"
                  /></a>
                </div>
              </div>
            </div>
            <div class="scrollable-x">
              <table
                class="table table-striped focus-on clientLst-table layout-fixed"
              >
                <thead>
                  <tr>
                    <th>Registration Date</th>
                    <th>Sub-Aff. Name</th>
                    <th>Country</th>
                    <th>Clients</th>
                    <th>Verified Clients</th>
                    <th>Funded Clients</th>
                    <th>Volume</th>
                    <th>Total Comm.</th>
                    <th>Sub-Affiliate Comm.</th>
                    <th>My Comm.</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody v-if="subIbList.totalRecords > 0">
                  <tr v-for="value in subIbList.records">
                    <td
                      v-html="
                        value.created != '' && value.created != null
                          ? getHumanDate(value.created)
                          : '-'
                      "
                    ></td>
                    <td
                      v-html="
                        value.username != '' && value.username != null
                          ? value.username
                          : '-'
                      "
                    ></td>
                    <td
                      v-html="
                        value.country != '' && value.country != null
                          ? value.country
                          : '-'
                      "
                    ></td>
                    <td
                      v-html="
                        value.total_client != '' && value.total_client != null
                          ? value.total_client
                          : '0'
                      "
                    ></td>
                    <td
                      v-html="
                        value.verified_client != '' &&
                        value.verified_client != null
                          ? value.verified_client
                          : '0'
                      "
                    ></td>
                    <td
                      v-html="
                        value.total_funded != '' && value.total_funded != null
                          ? value.total_funded
                          : '0'
                      "
                    ></td>
                    <td
                      v-html="
                        value.totalVolume != '' && value.totalVolume != null
                          ? value.totalVolume
                          : '-'
                      "
                    ></td>
                    <td
                      v-html="
                        value.totalRevenue != '' && value.totalRevenue != null
                          ? value.totalRevenue
                          : '-'
                      "
                    ></td>
                    <td
                      v-html="
                        value.subIbCommission != '' &&
                        value.subIbCommission != null
                          ? value.subIbCommission
                          : '-'
                      "
                    ></td>
                    <td
                      v-html="
                        value.myCommission != '' && value.myCommission != null
                          ? value.myCommission
                          : '-'
                      "
                    ></td>
                    <td
                      class="funded"
                      v-html="value.status == 1 ? 'Active' : 'Inactive'"
                    ></td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="11">
                      <loader
                        :pageloader_value="pageLoader"
                        :type="'table'"
                        :colspan="col_span"
                        :list="subIbList"
                        v-if="pageLoader == false"
                      ></loader>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <app-pagination
              :getList="subIbList"
              :pageLimit_parent="pageLimit"
              v-if="subIbList.totalRecords > 15"
            ></app-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import moment from "moment";
import { fxViewMixins } from "@/plugins/fxView";
export default {
  name: "SUB-AFFILIATE-DETAILS",
  mixins: [fxViewMixins],
  data() {
    return {
      pageTitle: this.$options.name,

      pageLoader: false,
      response_msg: "",
      msg_type: "",
      page: "1",
      col_span: 11,
      filterShow: false,
      disable: false,
      openToggle: false,
      submittedRequest: false,
      statInfo: {
        interval: "",
        from: "",
        to: "",
      },

      dashboardOtherData: {},
      totalSubIB: [],
      totalclient: [],

      filter_selected: "0",
      fromDate: [],
      toDate: "",
      allFilters: [],
      search: "",
      pageLimit: 15,
      selectKey: "0",
      righthand: "verified",
      main: {
        type: "select",
        value: "Status",
        fieldname: "Status",
        conditions: {
          Is: "=",
          "Is Not": "!=",
        },
        optionField: {
          Verified: "verified",
          Active: "active",
          HighRisk: "highrisk",
          Pro: "pro",
          "Completed Registeration": "completed",
          "New Update": "any_unread_for_admin",
        },
      },
      searchString: [],
      fundedAmount: "",
      condition: "!=",
      dateRange: "7",
      mainArray: {
        status: {
          type: "select",
          value: "Status",
          fieldname: "Status",
          conditions: {
            Is: "=",
            "Is Not": "!=",
          },
          optionField: {
            Verified: "verified",
            Active: "active",
            HighRisk: "highrisk",
            "Completed Registeration": "completed",
            "New Update": "any_unread_for_admin",
            Pro: "pro",
          },
        },
        date: {
          type: "date",
          value: "created",
          fieldname: "Created Date",
          conditions: {
            Is: "=",
            "Is Not": "!=",
            "Is Less Than": ">",
            "Is Greater Than": "<",
          },
        },
        OverallDeposit: {
          type: "text",
          value: "total_deposit",
          fieldname: "Overall Deposit",
          conditions: {
            Is: "=",
            "Is Not": "!=",
            "Is Less Than": ">",
            "Is Greater Than": "<",
          },
        },
        Deposit: {
          type: "text",
          value: "highest_deposit",
          fieldname: "Single Deposit",
          conditions: {
            Is: "=",
            "Is Not": "!=",
            "Is Less Than": ">",
            "Is Greater Than": "<",
          },
        },
        withdrwal: {
          type: "text",
          value: "total_withdrawal",
          fieldname: "Overall withdarwal",
          conditions: {
            Is: "=",
            "Is Not": "!=",
            "Is Less Than": ">",
            "Is Greater Than": "<",
          },
        },
        Name: {
          type: "text",
          value: "firstname",
          fieldname: "Name",
          conditions: {
            Is: "=",
            "Is Not": "!=",
            Contains: "contains",
            Not_contains: "not_contains",
            "Starts with": "startwith",
            "Ends with": "endswith",
          },
        },
        email: {
          type: "text",
          value: "email",
          fieldname: "Email",
          conditions: {
            Is: "=",
            "Is Not": "!=",
            Contains: "contains",
            Not_contains: "not_contains",
            "Starts with": "startwith",
            "Ends with": "endswith",
          },
        },
      },
    };
  },
  methods: {
    maxDate() {
      // return moment().format("YYYY-MM-DD");
      const today = new Date()
      const yyyy = today.getFullYear()
      const mm = String(today.getMonth() + 1).padStart(0,0)
      const dd = String(today.getDate()).padStart(0,0);
      return `${yyyy}-${mm}-${dd}`
    },
    eventInterValFl(interval, eventType) {
      if (eventType == "stat") {
        this.statInfo.interval = interval;
        if (this.statInfo.interval != "custom") {
          this.statInfo.from = this.statInfo.to = "";
          this.listing();
        } else if (
          this.statInfo.interval == "custom" &&
          this.statInfo.from != "" &&
          this.statInfo.to != ""
        ) {
          this.listing();
          //this.openToggle = !this.openToggle
        } else if (this.statInfo.interval == "") {
          this.listing();
        }
      }
    },
    getHumanDate(date) {
      return this.$parent.dateDDMMFormat(date);
    },
    resCounFunc(getData) {
      let countryString = [];
      countryString = this.countriesList.filter((list) => list.iso2 == getData);
      return countryString[0].name;
    },
    filter(getData) {
      this.selectKey = getData;
      this.$refs.form.resetdata();
    },
    removeFilter(removeindex) {
      const filterApplied = this.allFilters;

      if (filterApplied.length == 1) {
        this.allFilters.splice(removeindex, 1);
        this.searchString.splice(removeindex, 1);
      } else if (
        filterApplied.length > 1 &&
        removeindex == filterApplied.length - 1
      ) {
        this.allFilters.splice(removeindex - 1, 2);
        this.searchString.splice(removeindex - 1, 2);
      } else {
        this.allFilters.splice(removeindex, 2);
        this.searchString.splice(removeindex, 2);
      }
    },
    and() {
      if (this.condition != "") {
        if (this.condition == "contains") {
          this.righthand = this.righthand.toLowerCase();

          this.condition = 'LIKE "%' + this.righthand + '%"';
          this.righthand = "";
        }
        if (this.condition == "startwith") {
          this.righthand = this.righthand.toLowerCase();
          this.condition = "LIKE '%" + this.righthand + "'";
          this.righthand = "";
        }
        if (this.condition == "endswith") {
          this.righthand = this.righthand.toLowerCase();
          this.condition = "LIKE '" + this.righthand + "%'";
          this.righthand = "";
        }
        let filterTest = {};
        filterTest.fieldname = this.main.value;
        filterTest.conditions = this.condition;
        filterTest.fieldvalue = this.righthand;

        this.allFilters.push(filterTest);

        this.allFilters.push("and");

        //
        this.searchString.push(
          this.main.value + "  " + this.condition + " " + this.righthand
        );

        // this.searchString.push('and')

        this.main = {};
        this.condition = "";
        this.righthand = "";
      }
    },
    or() {
      if (this.condition != "") {
        if (this.condition == "contains") {
          this.righthand = this.righthand.toLowerCase();

          this.condition = 'LIKE "%' + this.righthand + '%"';
          this.righthand = "";
        }
        if (this.condition == "startwith") {
          this.righthand = this.righthand.toLowerCase();
          this.condition = "LIKE '%" + this.righthand + "'";
          this.righthand = "";
        }
        if (this.condition == "endswith") {
          this.righthand = this.righthand.toLowerCase();
          this.condition = "LIKE '" + this.righthand + "%'";
          this.righthand = "";
        }
        let filterTest = {};
        filterTest.fieldname = this.main.value;
        filterTest.conditions = this.condition;
        filterTest.fieldvalue = this.righthand;
        this.allFilters.push(filterTest);
        this.allFilters.push("or");

        // this.searchString.push('or')
        //thi
        this.searchString.push(
          this.main.value + "  " + this.condition + " " + this.righthand
        );

        this.main = {};
        this.condition = "";
        this.righthand = "";
      }
    },
    searchFilter() {
      if (this.condition !== "") {
        if (this.allFilters.length > 0) {
          if (typeof this.allFilters[this.allFilters.length - 1] == "object") {
            this.allFilters.push("and");
            this.searchString.push("and");
          }
        }
        if (this.condition == "contains") {
          this.righthand = this.righthand.toLowerCase();

          this.condition = 'LIKE "%' + this.righthand + '%"';
          this.righthand = "";
        }
        if (this.condition == "startwith") {
          this.righthand = this.righthand.toLowerCase();
          this.condition = "LIKE '%" + this.righthand + "'";
          this.righthand = "";
        }
        if (this.condition == "endswith") {
          this.righthand = this.righthand.toLowerCase();
          this.condition = "LIKE '" + this.righthand + "%'";
          this.righthand = "";
        }
        let filterTest = {};
        filterTest.fieldname = this.main.value;
        filterTest.conditions = this.condition;
        filterTest.fieldvalue = this.righthand;
        this.allFilters.push(filterTest);

        this.searchString.push(
          this.main.value + "  " + this.condition + " " + this.righthand
        );

        // this.main = {}
        // this.condition = ''
        // this.righthand = ''
      }

      if (this.condition == "") {
        if (this.allFilters.length > 0) {
          if (typeof this.allFilters[this.allFilters.length - 1] !== "object") {
            this.allFilters.splice(-1, 1);
            this.searchString.splice(-1, 1);
          }
        }
      }

      let inputJson = {
        globalParams: {
          filter: {},
          sort: [],
          search: this.search,
          page: this.page,
          perPage: this.pageLimit,
        },
        localParams: { parameter: this },
      };
      inputJson.globalParams.filter = this.allFilters;

      this._runGetUserList(inputJson);

      //console.log(this.allFilters)
    },
    listing() {
      let inputJson = {
        globalParams: {
          filter: {},
          sort: [],
          search: this.search,
          page: this.page,
          perPage: this.pageLimit,
          stat_interval: this.statInfo.interval,
          stat_from_interval: this.statInfo.from,
          stat_to_interval: this.statInfo.to,
        },
        localParams: { parameter: this },
      };
      if (this.selectKey == "1") {
        inputJson.globalParams.filter["AUSER.active"] = 1;
      } else if (this.selectKey == "2") {
        inputJson.globalParams.filter["AUSER.active"] = 2;
      } else if (this.selectKey == "3") {
        inputJson.globalParams.filter["AUSER.verified_status"] = 1;
      } else if (this.selectKey == "4") {
        inputJson.globalParams.filter["AUSER.verified_status"] = 0;
      } else if (this.selectKey == "5") {
        inputJson.globalParams.filter["AUSER.any_unread_for_admin"] = 1;
      }
      this._runUserSubIbList(inputJson);
    },
    csvExport(arrData, type, getFileName) {
      let csv = "data:text/csv;charset=utf-8,";
      //console.log("data",arrData)

      const _that = this;
      csv +=
        "Registration Date,Sub-Aff. Name,Country,Clients,Verified Clients,Funded Clients,Volume,Total Comm.,Sub-Affiliate Comm.,My Comm.,Status \n";
      arrData.forEach(function (row) {
        let status = row.status == 1 ? "Active" : "Inactive";
        csv +=
          _that.getHumanDate(row.created) +
          "," +
          row.username +
          "," +
          row.country +
          "," +
          row.total_client +
          "," +
          row.verified_client +
          "," +
          row.total_funded +
          "," +
          row.totalVolume +
          "," +
          row.totalRevenue +
          "," +
          row.subIbCommission +
          "," +
          row.myCommission +
          "," +
          status;
        csv += "\n";
      });

      const link = document.createElement("a");
      const data = encodeURI(csv);
      link.setAttribute("href", data);
      link.setAttribute("download", getFileName);
      //console.log("link",link)
      link.click();
    },
  },
  created() {
    this.setData(this.pageTitle);
    this.listing();

    this._runApiDashboardData({
      globalParams: {
        "for": "SUB_AFFILIATE"
      },
      localParams: { parameter: this },
    });
    // this._runGetDashboardOtherData({'globalParams' : {} ,'localParams' : {'parameter' : this}})
    // this._runGetTotalClient({'globalParams' : {} ,'localParams' : {'parameter' : this}})
    // this._runGetTotalSubIb({'globalParams' : {} ,'localParams' : {'parameter' : this}})
    //this._runUserCount({'globalParams' : {} ,'localParams' : {'parameter' : this}})
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/ib/sub_ib_detail.vue